/* ============
 * Application Mutations
 * ============
 *
 * The mutations available for the application module.
 */

export const OPEN_SNACKBAR = 'OPEN_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const LOADING_START = 'LOADING_START';
export const LOADING_FINISH = 'LOADING_FINISH';
/* export const UPDATE_USERNEEDFINALIZATION = 'UPDATE_USERNEEDFINALIZATION'; */

export default {
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR,
  LOADING_START,
  LOADING_FINISH,
  // UPDATE_USERNEEDFINALIZATION,
};



// WEBPACK FOOTER //
// ./src/store/modules/application/types.js